import React from 'react';
import {
  Action,
  Notifications as NotificationsIcon,
  SectionList,
  SectionListItem,
} from '@sail/ui';

/* eslint-disable no-console */

const basic = {
  rendered: (
    <SectionList
      onAction={(key) => console.log(key)}
      aria-label="Example of a SectionList"
    >
      <SectionListItem>
        <div>Category 1</div>
        <div slot="description">Description</div>
      </SectionListItem>
      <SectionListItem>
        <div>Category 2</div>
      </SectionListItem>
      <SectionListItem>
        <Action onPress={(e) => console.log(e)}>Category 3 Action</Action>
        <Action onPress={(e) => console.log(e)} slot="description">
          Description Action
        </Action>
      </SectionListItem>
      <SectionListItem size="default">
        <div>Category 4</div>
      </SectionListItem>
      <SectionListItem size="large">
        <div slot="description">Description</div>
        <div>Category 5</div>
        <NotificationsIcon slot="icon" />
      </SectionListItem>
      <SectionListItem value="$100.00">
        <div>Category 7</div>
        <NotificationsIcon slot="icon" />
      </SectionListItem>
      <SectionListItem value="$100.00">
        <div>Category 8</div>
      </SectionListItem>
    </SectionList>
  ),
  source: `<SectionList
  onAction={(key: string | number) => console.log(key)}
  aria-label="Example of a SectionList"
>
  <SectionListItem>
    <div>Category 1</div>
    <div slot="description">Description</div>
  </SectionListItem>

  <SectionListItem>
    <div>Category 2</div>
  </SectionListItem>

  <SectionListItem>
    <Action onPress={(e) => console.log(e)}>Category 3 Action</Action>
    <Action onPress={(e) => console.log(e)} slot="description">
      Description Action
    </Action>
  </SectionListItem>

  <SectionListItem size="default">
    <div>Category 4</div>
  </SectionListItem>

  <SectionListItem size="large">
    <div slot="description">Description</div>
    <div>Category 5</div>
    <NotificationsIcon slot="icon" />
  </SectionListItem>

  <SectionListItem value="$100.00">
    <div>Category 7</div>
    <NotificationsIcon slot="icon" />
  </SectionListItem>

  <SectionListItem value="$100.00">
    <div>Category 8</div>
  </SectionListItem>
</SectionList>`,
};

export const SectionListExamples = {basic};
